export const RESOURCE_TYPES = {
    user: 'user',
    agency: 'agency',
} as const;

export type RESOURCE_TYPE = ValueOf<typeof RESOURCE_TYPES>;
